import { render, staticRenderFns } from "./LKPublicationsContainer.vue?vue&type=template&id=1c689c63&"
import script from "./LKPublicationsContainer.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsContainer.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports